<convfact-investment-property-form [investmentProperty]="investmentProperty" [accounts]="accounts" (onSave)="saveData($event)">
</convfact-investment-property-form>
